<template>
  <div class="login-wrap">
    <div class="loginbox flex">
      <div class="whilefont">
        <div>欢迎使用</div>订单统一发货系统
      </div>
      <div class="ms-login">
        <div class="ms-title">系统登录</div>
        <el-form :model="params" :rules="rules" ref="login" label-width="0px" class="ms-content">
          <div class="tip"></div>
          <el-form-item prop="username">
            <el-input v-model="params.username" placeholder="请输入账号">
              <el-button slot="prepend" icon="el-icon-lx-people"></el-button>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input type="password" placeholder="请输入密码" v-model="params.password" @keyup.enter.native="submitForm()">
              <el-button slot="prepend" icon="el-icon-lx-lock"></el-button>
            </el-input>
          </el-form-item>
          <div class="login-btn">
            <el-button type="primary" @click="submitForm()">登录</el-button>
          </div>
          <p class="login-tips" @click="forgetpw" v-if="0">忘记密码</p>
        </el-form>
      </div>
    </div>

  </div>
</template>

<script>
  import api from '../../services/login/api.js'
  import cookie from '../../common/cookie.js'
  export default {
    data: function() {
      return {
        params: {
          username: '',
          password: '',
        },
        rules: {
          username: [{
            required: true,
            message: '请输入账号',
            trigger: 'blur'
          }],
          password: [{
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          }],
        },
      };
    },
    created() {
      if (cookie.getToken()) {
        this.$router.push({
          path: '/'
        })
      }
    },
    methods: {
      submitForm() {
        this.$refs.login.validate(valid => {
          if (valid) {
            api.login(this.params).then((res) => {
              cookie.setToken(res.data.deliveryToken)
              cookie.set('activeIndex', '1')
              this.$message.success('登录成功');
              this.$router.push('/');
            })
          } else {
            this.$message.error('请输入账号和密码');
            return false;
          }
        });
      },
      forgetpw() {
        this.$confirm('找回密码，请致电 400-609-1090', "", {
          confirmButtonText: '关闭',
          showCancelButton: false,
          center: "center",
          showClose: false
        }).then(() => {

        })
      },
    },
  };
</script>

<style lang="scss">
  .loginbox {
    position: absolute;
    align-items: unset;
    left: 50%;
    padding: 0.5rem;
    top: 50%;
    background-image: url(../../assets/img/lcover.png);
    background-size: 100% 100%;
    width: 23.5rem;
    height: 9.66rem;
    margin: -4.83rem 0 0 -11.55rem;

    .whilefont {
      color: #fff;
      flex: 1;
      padding: 1.85rem 0 0 0.8rem;
      font-size: 0.76rem;
      line-height: 1;

      >div {
        padding-bottom: 0.5rem;
      }
    }

    .tip {
      font-size: 0.4rem;
      color: #333333;
      margin: 0 0 0.4rem 0.2rem;
    }

    .el-input-group__append,
    .el-input-group__prepend {
      background-color: #fff;
      border-color: transparent transparent #DCDFE6 transparent;
      border-radius: 0;
      font-size: 0.45rem;
      padding: 0 0.3rem;
    }

    .el-input-group>.el-input__inner {
      background-color: #fff !important;
    }

    .el-input__inner {
      border-color: #fff #fff #DCDFE6 #fff !important;
      padding: 0;
    }

    input:-internal-autofill-selected {
      background-color: #fff !important;
    }

    input:-webkit-autofill {
      box-shadow: 0 0 0px 1000px white inset !important;
    }
  }

  .login-wrap {
    position: relative;
    width: 100%;
    height: 100vh;
    background-image: url(../../assets/img/login-bg.jpg);
    background-size: 100% 100%;
    border: 1px solid #000000;
  }

  .ms-title {
    width: 100%;
    text-align: center;
    font-size: 0.68rem;
    color: #042B58;
    padding: 1rem 0 0.5rem;
    line-height: 1;
  }

  .ms-login {

    width: 9.22rem;
    margin: 0;
    border-radius: 5px;
    background: rgba(255, 255, 255, 1);
    overflow: hidden;
  }

  .ms-content {
    padding: 0 1rem;
  }

  .login-btn {
    text-align: center;
    margin: 0.8rem 0 0.3rem;
  }

  .login-btn button {
    width: 90%;
    font-size: 0.4rem;
    margin: 0 auto;
    background: #042B58;
  }

  .login-tips {
    font-size: 13px;
    line-height: 30px;
    text-align: center;
    color: #042B58;
  }
</style>



// WEBPACK FOOTER //
// src/views/login/login.vue